import styled from 'styled-components/macro'
import Box from 'components/shared/Box'
import { respondAbove } from 'styles/mediaQueries'
import SeparatedList from 'components/shared/SeparatedList'
import { scrollbar } from 'styles/mixins'
import { AppMode } from 'helpers/types'

interface SummaryListWrapperProps {
    mode?: AppMode
}

export const SummaryBoxWrapper = styled.div`
    width: 100%;
`

export const SummaryListWrapper = styled(
    SeparatedList
)<SummaryListWrapperProps>`
    background-color: ${({ theme }) => theme.colors.grayscale_0};
    border-radius: 8px;

    @media ${respondAbove.xl} {
        position: sticky;
        top: 24px;
        margin-top: 74px;
        margin-top: ${(props) =>
            props.mode === 'unlimited-card' ||
            props.mode === 'unlimited-renew' ||
            props.mode === 'vouchers'
                ? '139px'
                : '74px'};
        margin-bottom: 244px;
        .summaryPrice {
            min-width: 62px;
        }
        > div {
            padding: 16px 16px 0;
        }
        > div:nth-of-type(1) {
            ${scrollbar};
            max-height: 321px;
            overflow-y: auto;
            overflow-x: hidden;
            padding-bottom: 16px;
        }
        > div:last-of-type {
            margin-top: 0;
        }
    }
`

export const LoaderWrapper = styled(Box)`
    min-height: 90vh;
    width: 26px;
    margin: auto;
    @media ${respondAbove.xl} {
        min-height: 0;
        width: auto;
    }
`

interface SummaryItemWrapperProps {
    isTruncable?: boolean
}
export const SummaryItemWrapper = styled(Box)<SummaryItemWrapperProps>`
    ${({ isTruncable }) =>
        isTruncable &&
        `
        @media ${respondAbove.xl} {
            .summaryPrice {
                min-width: fit-content;
            }
        }
    `}
`
